export const ENV = {
  apiUrl: import.meta.env.VITE_API_URL ?? 'http://localhost:4000',
  devLogin: import.meta.env.VITE_DEV_LOGIN === 'true',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN as string | undefined,
  stripeEnabled: import.meta.env.VITE_STRIPE_ENABLED !== 'false',
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY as string | undefined,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN as string | undefined,
    projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID as string | undefined,
    appId: import.meta.env.VITE_FIREBASE_APP_ID as string | undefined,
  },
};
